<template>
  <div style="clear: both">
    <v-divider></v-divider>

    <v-list dense class="pt-0">
      <v-list-item v-for="(link, index) in links" :key="index" @click="onLinkClick(link)" :title="link.title">
        <template v-slot:prepend>
          <v-tooltip :text="link.title">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" :icon="link.icon"></v-icon>
            </template>
          </v-tooltip>
        </template>
      </v-list-item>

      <v-list-group value="Admin" v-if="isProcessManagerOrItSupport || canSeeAdmin">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" title="Admin">
            <template v-slot:prepend>
              <v-tooltip text="Admin">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" icon="mdi-cog-outline"></v-icon>
                </template>
              </v-tooltip>
            </template>
          </v-list-item>
        </template>

        <v-list-item v-for="(link, index) in adminLinksFiltered" :key="index" :to="link.path" :title="link.title">
          <template v-slot:prepend>
            <v-tooltip :text="link.title">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" :icon="link.icon"></v-icon>
              </template>
            </v-tooltip>
          </template>
        </v-list-item>
      </v-list-group>

      <v-list-group value="Developer" v-if="isItSupport">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" prepend-icon="mdi-developer-board" title="Developer">
            <template v-slot:prepend>
              <v-tooltip text="Developer">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" icon="mdi-developer-board"></v-icon>
                </template>
              </v-tooltip>
            </template>
          </v-list-item>
        </template>

        <v-list-item v-for="(link, index) in developerLinks" :key="index" :to="link.path" :title="link.title">
          <template v-slot:prepend>
            <v-tooltip :text="link.title">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" :icon="link.icon"></v-icon>
              </template>
            </v-tooltip>
          </template>
        </v-list-item>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import { EventBus } from '@/common/event-bus'
export default {
  data() {
    return {
      links: [{ icon: 'mdi-home-outline', title: 'Home', path: '/home', onClick: this.onHomeClick }],
      adminLinks: [
        { icon: 'mdi-cog-box', title: 'Community Configuration', path: '/communityconfiguration', showToAdmin: true },
        { icon: 'mdi-find-replace', title: 'User Replacement (Config)', path: '/userreplacement', showToOwnerOnly: true },
        { icon: 'mdi-find-replace', title: 'User Replacement (MOC)', path: '/userreplacementmoc', showToOwnerOnly: true },
        { icon: 'mdi-content-copy', title: 'Clone Community', path: '/clonecommunity' },
        { icon: 'mdi-account-multiple-outline', title: 'Process Managers', path: '/processmanager' },
        { icon: 'mdi-bullhorn-outline', title: 'News', path: '/news', showToOwnerOnly: true },
        { icon: 'mdi-help-circle', title: 'IT Support', path: '/itsupport' },
        { icon: 'mdi-server', title: 'DB Access Control', path: '/dbaccesscontrol' },
        { icon: 'mdi-translate', title: 'Display Label Keys', path: '/translations' }
      ],
      developerLinks: [
        { icon: 'mdi-stretch-to-page-outline', title: 'Display Names Override', path: '/itsupport/displaynameoverride' },
        { icon: 'mdi-email-outline', title: 'Notification Tester', path: '/itsupport/notificationtester' }
      ],
      mini: true
    }
  },
  props: {
    roles: Array
  },
  computed: {
    currentCommunity() {
      return this.$store.state.currentCommunity.community
    },
    isProcessManagerOrItSupport() {
      return this.roles.find((x) => x.toLowerCase() === 'itsupport' || x.toLowerCase() === 'processmanager')
    },
    isItSupport() {
      return this.roles.find((x) => x.toLowerCase() === 'itsupport')
    },
    canSeeAdmin() {
      return this.roles.find((x) => x.toLowerCase() === 'communityowner' || x.toLowerCase() === 'leadfacilitator')
    },
    isCommunityOwner() {
      return this.roles.find((x) => x.toLowerCase() === 'communityowner')
    },
    adminLinksFiltered() {
      return this.adminLinks.filter((link) => {
        if (this.isProcessManagerOrItSupport) {
          return true
        }
        if (link.showToAdmin && this.canSeeAdmin) {
          return true
        }
        if (link.showToOwnerOnly && this.isCommunityOwner) {
          return true
        }
        return false
      })
    }
  },
  methods: {
    onLinkClick(link) {
      if (link.path.toLowerCase() === '/home') {
        this.$store.dispatch('currentCommunity/setCommunity', {})
      }

      if (this.$route.path.toLowerCase() !== link.path.toLowerCase()) {
        this.$router.push(link.path)
      }

      EventBus.emit('updateNavRoles')
    },
    setCommunityInStore(community) {
      if (community && community.communityAbbreviation) {
        const index = this.links.findIndex((l) => l.communityDashboard)
        const link = {
          icon: 'mdi-view-dashboard-outline',
          title: `${community.communityAbbreviation.toUpperCase()} Dashboard`,
          path: `/${community.communityAbbreviation}/CommunityDashboard`,
          communityDashboard: true
        }
        if (index > 0) {
          this.links.splice(index, 1, link)
        } else {
          this.links.push(link)
        }
      } else {
        const index = this.links.findIndex((l) => l.communityDashboard)
        if (index > 0) {
          this.links.splice(index, 1)
        }
      }
    }
  },
  created() {
    if (this.$route.path.toLowerCase() === '/home') {
      this.$store.dispatch('currentCommunity/setCommunity', {})
      return
    }

    if (
      this.$route.name &&
      this.$route.name.toLowerCase() === 'communitydashboard' &&
      this.$route.params &&
      this.$route.params.shortName &&
      this.$route.params.shortName.trim()
    ) {
      this.setCommunityInStore({
        communityAbbreviation: this.$route.params.shortName
      })
      return
    }

    this.setCommunityInStore(this.currentCommunity)
  },
  watch: {
    currentCommunity(newValue) {
      this.setCommunityInStore(newValue)
    },
    $route() {
      console.log(`nav.vue watch $route`);
      this.$store.dispatch('currentCommunity/setCommunity', {
        communityAbbreviation: this.$route.params.shortName
      })
    }
  }
}
</script>

<style>
.v-list-item-title {
  font-size: 0.8rem !important;
  font-weight: 500 !important;
  line-height: 1rem !important;
}
.v-list-group__items > .v-list-item {
  padding-inline-start: 16px !important;
}
.v-list-group__header > .v-list-item__content {
  padding-left: 16px !important;
}
.v-list-item--density-default.v-list-item--one-line {
  min-height: 40px !important;
}
</style>
